(function() {
  const progressBar = document.querySelector('.post-full-reading-progress-bar');

  const getDocHeight = () => {
    return Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
    );
  };

  const amountScrolled = () => {
    const winheight= window.innerHeight || (document.documentElement || document.body).clientHeight;
    const docHeight = getDocHeight();
    const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const trackLength = docHeight - winheight;
    const percentageScrolled = scrollTop/trackLength * 100;
    progressBar.style.width = percentageScrolled + '%';
  };

  progressBar && window.addEventListener('scroll', () => {
    amountScrolled();
  }, false);

  hljs.initHighlightingOnLoad();

  const altPostLanguage = document.querySelector('[rel="alternate"][hreflang]');
  if(altPostLanguage) {
    document.querySelector('.site-nav .site-nav-language > .enable').href = altPostLanguage.href;
  }
})();

const tagImageHover = (elem, type) => {
  const separators = elem.parentElement.querySelectorAll('.post-card-separator');
  for(const separator of separators)
    separator.classList.toggle('on-hover', type === 'in')
};